import { IconTruck, Text } from '@vtex/admin-ui'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import type { ShippingMethods as ShippingMethodsType } from 'typings'
import { Tag, TagsListTruncate } from '../../../Tag'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { RuleDefaultActions } from '../../RuleStack/DefaultActions'
import { messages } from './messages'

type Props = {
  values: ShippingMethodsType | undefined
  onEdit: () => void
  onRemove: () => void
}

export function ShippingMethodsView(props: Props) {
  const { values, onEdit, onRemove } = props
  const { formatMessage: i18n } = useIntl()

  const [rulesWidth, setRulesWidth] = useState<number>(0)

  const initRulesWidth = (element: HTMLDivElement | null) => {
    element?.clientWidth && setRulesWidth(element.clientWidth)
  }

  if (!values) return null

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconTruck />
      </RuleIcon>

      <RuleDescription>
        {i18n(messages.view.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
          count: values.length,
        })}
      </RuleDescription>

      <RuleContent ref={initRulesWidth}>
        <TagsListTruncate
          maxWidth={rulesWidth}
          content={values.map(({ name }) => name)}
        >
          {values.map(({ name }, index) => (
            <TagsListTruncate.Atom key={index}>
              <Tag>{name}</Tag>
            </TagsListTruncate.Atom>
          ))}
        </TagsListTruncate>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
